<template>
  <div class="applist_component page-wrap center-item-to-body">
    <div class="container-box">
      <div class="container-box__logo">
        <router-link to="/">
          <img alt="beurer logo" src="@/assets/logo_beurer.png">
        </router-link>
      </div>
      <div class="container-box__content">
        <ul class="applist" v-if="!errorMessage">
          <li class="applist-child" v-for="(item, key) in applistContent" :key="key" >
            <router-link :to="'app/'+item.appName.replace(' ', '')">
            <!-- <img class="applist-child__logo" :src="item.logoUrl" :alt="item.appName"> -->
            <div class="applist-child__logo">
              <img :src="item.logoUrl" :alt="item.appName">
            </div>
           <span class="applist-child__list">
             <span class="app-title">{{ item.appName }} </span>
           </span>
           </router-link>
          </li>

          <!-- ADD NEW APP -->
          <li class="applist-child">
            <router-link to="/addnewapp">
            <div class="applist-child__logo">
              <i class="material-icons">add_circle</i>
            </div>
           <span class="applist-child__list">
             <span class="app-title">Add New</span>
           </span>
           </router-link>
          </li>

        </ul>
        <div class="ip-error__container" v-else>
          <div class="ip-error__content">Your IP ({{this.errorMessage}}) has no access to this feature.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService'

export default {
  name: 'TheAppList',
  props: {
  },
  data: function () {
    return {
      apiService: new ApiService(),
      applistContent: [],
      errorMessage: null
    }
  },
  mounted () {
    var prom = this.getAppListContent()
    prom.then((err) => {
      if (err) {
        Promise.resolve(err).then((value) => {
          this.errorMessage = value
        })
      }
    })
  },
  methods: {
    getAppListContent () {
      return new Promise(resolve => {
        var ret = this.apiService.getAppList().then(result => {
          this.applistContent = result.appList
        }).catch((err) => {
          // console.log('getAppListContent err: ', err)
          return err
        })

        resolve(ret)
      })
    }
  }
}
</script>

<style lang="scss">
  @import "@/scss/main.scss";

  .applist_component{
    display: flex;
    justify-content: center;
    align-self: center;
    height: 80vh;
  }

  .ip-error {
    &__container {
      display: flex;
      align-items: center;
    }

    &__content {
      flex: 0 1 auto;
    }
  }

  .container-box{
      &__content{
        .applist{
          display: flex;
          flex-flow: row wrap;
          justify-content: center;//space-between;
          align-content: center;
          list-style: none;
          padding: rem(20) rem(5) 0 rem(5);

          &-child{
            display: flex;
            flex-flow: row nowrap;
            position: relative;
            display: inline-block;
            overflow: hidden;
            width: rem(90);
            height: rem(90);
            padding: rem(20) rem(5);
            margin: auto rem(5) rem(10) rem(5);
            border-radius: 100%;
            border: rgba($dark-light, 0.8) solid 8px;
            @include breakpoint(tablet){
              padding: rem(20) rem(5);
              margin: auto rem(10) rem(15) rem(10);
              width: rem(140);
              height: rem(140);
            }
            &__logo{
              width: 100%;
              height: 100%;

              > img {
                position: absolute;
                width: 200%;
                height: 200%;
                top: -35%;
                left: -50%;
              }

              .material-icons{
                color: $primary;
                font-size: rem(80);
                line-height: rem(80);
              }
            }
            &__list{
                display: flex;
                text-align: center;
                position: absolute;
                justify-content: center;
                vertical-align:bottom;
                top: 50%;
                left: 0;
                width: 100%;
                height: 50%;
                border-radius: rem(80);
                z-index: 10;

              .app-title{
                width: 80%;
                padding: rem(2) rem(2) rem(8) rem(2);
                margin: 0 auto;
                text-decoration: none;
                font-weight: 700;
                text-align: center;
                line-height: rem(12);
                font-size: rem(12);
                color: $primary;
                background-color: rgba($light, 0.8);
                align-self: flex-end;
              }
            }

            &:before {
              content: '';
              position: absolute;
              top: 105%;
              left: 0;
              width: 100%;
              height: rem(50);
              background-color: $primary;
              opacity: 0;
              transition: 0.1s;
              transition-delay: 0.1s;
              transition-property: all;
              z-index: 9;
            }

            &:after {
              content: '';
              position: absolute;
              top: 105%;
              left: calc(50% - 5px);
              width: rem(10);
              height: rem(10);
              z-index: 10;
              transform: rotate(135deg);
              background-color: $primary;
              opacity: 0;
              transition: 0.1s;
              transition-property: all;
            }

            &:hover{
              cursor: pointer;
              background-color: rgba($dark-light, 0.25);
              box-shadow: 0px 4px 10px 2px rgba(41, 41, 41, 0.35);
              transform: scale(1.02);
              transition: 0.2s;
              transition-property: all;
              color: $light;

              .applist-child__list{
                .app-title{
                  color: $light;
                  background-color: rgba($light, 0);
                }
              }

              &:before {
                top: calc(100% - 30px);
                opacity: 1;
                transition: 0.2s;
                transition-property: all;
                @include breakpoint(tablet){
                  top: calc(100% - 40px);
                }
              }

              &:after {
                top: calc(100% - 35px);
                opacity: 1;
                transition: 0.2s;
                transition-delay: 0.1s;
                transition-property: all;
                @include breakpoint(tablet){
                  top: calc(100% - 45px);
                }
              }
            }

            &:active{
              border: rgba($primary, 0.8) solid 1px;
              transform: translateY(4px);
              transition: 0.2s;
              &:before {
                top: calc(100% - 30px);
                opacity: 1;
                @include breakpoint(tablet){
                  top: calc(100% - 40px);
                }
              }
              &:after {
                top: calc(100% - 35px);
                opacity: 1;
                @include breakpoint(tablet){
                  top: calc(100% - 45px);
                }
              }
            }
          }
        }
      }
    }
</style>
